<template>
  <div>
    <div class="app-bar">
      <div class="app-bar__logo">
        <router-link to="/">
          <b-img
            src="./static/base/primary_Logo_2x_thumb.png"
            alt="Anchor Loans Logo"
            title="Anchors Loans Logo"
            class="app-bar__logo__img"
          />
        </router-link>
      </div>
      <div class="app-bar__actions">
        <slot name="actions">
        <span
          class="app-bar__actions__mobile-menu d-block d-md-none side_center"
          @click.prevent.stop="toggleMobileMenu"
        >
          <FontAwesomeIcon :icon="menuIcon" />
        </span>
        <span class="app-bar__actions__btn app-bar__actions__menu">
          <img :src="userAvatar" class="d-none avatar d-md-inline-block picture-container">
          <span class="d-none d-md-inline-block">{{ userName }}</span>
          <FontAwesomeIcon
            class="d-none d-sm-block app-bar__actions__menu__icon"
            icon="chevron-down"
          />
          <ul :class="menuClasses">
            <li
              class="app-bar__mobile-menu__item d-block d-md-none"
              v-for="item in items"
              :key="item.text"
            >
              <a
                class="app-bar__actions__menu__item"
                @click.prevent.stop="redirect(item.route.name)"
              >
                <FontAwesomeIcon
                  :icon="item.icon"
                  class="app-bar__actions__menu__item__icon"
                />
                {{ item.text }}
            </a>
            </li>
            <li class="d-block d-md-none">
              <hr>
            </li>
            <AnchorTeam />
            <li class="d-block d-md-none">
              <hr>
            </li>
            <li>
              <a
                class="app-bar__actions__menu__item"
                @click.prevent.stop="redirect('Settings')"
              >
                Account Settings
            </a>
            </li>
            <li>
              <a
                class="app-bar__actions__menu__item"
                @click.prevent.stop="logout"
              >
                Log out
            </a>
            </li>
            <li class="d-block d-sm-none">
              <hr>
            </li>
            <li v-if="isSubmitDealAllowed()">
              <a
                @click.prevent.stop="redirect('NewDeal')"
                class="app-bar__actions__btn__mobile app-bar__mobile-menu__item d-block d-md-none"
              >
                Submit New Loan
              </a>
            </li>
          </ul>

        </span>
          <span class="app-bar__actions__menu">
            <RouterLink
              v-if="canShowSubmitOnNavbar"
              to="/new_deal"
              class="app-bar__actions__btn app-bar__btn d-none d-md-block ml-5"
            >
              Submit New Loan
            </RouterLink>
          </span>
        </slot>
      </div>
      <VerificationUserEmail
        v-if="hasAuthenticatedUser"
        ref="verificationUserAlert"
        placement="bottomleft"
        target="get-loan"
      />
    </div>
    <b-alert
      v-model="showTeamMemberNotification"
      class="position-fixed rounded-0 team-notification mt-3"
      variant="warning"
    >
      You are logged in as {{teamMemberName}} and operating on behalf
      of borrower <strong>{{borrowerName}}</strong>.
    </b-alert>
  </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import {
  faAddressCard,
  faHandshake,
  faCheckCircle,
  faPlus,
  faChevronDown,
  faBars,
  faTimes,
  faCopy,
} from '@fortawesome/free-solid-svg-icons';
import ICONS from '@/assets/icons/icons';
import VerificationUserEmail from '@/components/utils/verification/VerificationUserEmail';
import { LOGOUT } from '@/vuex/types/actions';
import navigationLinks from '@/components/base/navbar/resources';
import { LOANS_WRITE } from '@/libs/permissions_list';
import AnchorTeam from '@/components/base/sidebar/AnchorTeam';

library.add([
  faAddressCard,
  faHandshake,
  faCheckCircle,
  faPlus,
  faChevronDown,
  faBars,
  faTimes,
  faCopy,
  ICONS.faPlaidIcon,
]);

export default {
  name: 'AnchorNavbarAuth',
  components: {
    AnchorTeam,
    FontAwesomeIcon,
    VerificationUserEmail,
  },
  data() {
    return {
      isMobileMenuOpen: false,
      items: navigationLinks.userItems,
      permissionList: [LOANS_WRITE],
    };
  },
  computed: {
    userAvatar() {
      return this.$store.getters.user.picture || '/static/profile/profile.svg';
    },
    userName() {
      return this.$store.getters.profile.contact.firstName;
    },
    hasAuthenticatedUser() {
      return this.$store.getters.hasAuthenticatedUser;
    },
    hasTeamsAreaRequired() {
      return this.$store.getters.hasTeamsAreaRequired;
    },
    menuClasses() {
      const classes = {
        'app-bar__user-menu': true,
        'app-bar__user-menu--open': this.isMobileMenuOpen,
      };
      return classes;
    },
    menuIcon() {
      return this.isMobileMenuOpen ? 'times' : 'bars';
    },
    showTeamMemberNotification() {
      const user = this.$store.getters.user;
      const profile = this.$store.getters.profile;
      if (profile && user) {
        if (profile.contact.email !== user.email) {
          return true;
        }
      }
      return false;
    },
    borrowerName() {
      const profile = this.$store.getters.profile;
      if (profile) {
        return `${profile.contact.firstName} ${profile.contact.lastName}`;
      }
      return '';
    },
    teamMemberName() {
      const user = this.$store.getters.user;
      if (user) {
        return `${user.firstName} ${user.lastName}`;
      }
      return '';
    },
    canShowSubmitOnNavbar() {
      return !this.hasTeamsAreaRequired && this.isSubmitDealAllowed();
    },
  },
  methods: {
    isSubmitDealAllowed() {
      return this.$permissions.checkPermissions([LOANS_WRITE]);
    },
    toggleMobileMenu() {
      this.isMobileMenuOpen = !this.isMobileMenuOpen;
    },
    confirmLogout() {
      this.$swal({
        title: 'Are you sure?',
        type: 'warning',
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          this.logout();
        }
      });
    },
    logout() {
      this.$reqs.post('/logout')
        .then(() => {
          this.$store.dispatch(LOGOUT);
        })
        .catch(() => {});
    },
    redirect(path) {
      this.toggleMobileMenu();
      this.$router.push({ name: path });
    },

  },
};
</script>

<style scoped>
.app-bar {
  --primary-color: #071b31;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  background-color: var(--primary-color);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1001;
}

.app-bar__logo {
  display: flex;
  flex-grow: 1;
}

.app-bar__logo__img {
  width: 100%;
  max-width: 150px;
  max-height: 1rem;
}

.app-bar__actions {
  display: flex;
  align-items: flex-end;
}

.app-bar__actions__btn,.app-bar__actions__menu {
  color: #ffffff;
  font-weight: 400;
  border-radius: 4px;
  font-size: 14px;
  line-height: 22px;
  padding: 6px 12px;
}

.app-bar__actions__btn__mobile{
  color: #ffffff !important;
  font-weight: 400;
  border: 1px solid var(--primary-color);
  background-color: var(--primary-color);
  border-radius: 4px;
  font-size: 14px;
  line-height: 22px;
  padding: 6px 12px;
  text-align: center;
  margin: 0 1rem;
}

.app-bar__btn {
  color: #051f3a;
  background-color: #36ffd9;
}

.app-bar__btn:hover {
  background-color: #00434e;
  color: #36ffd9;
  text-decoration: none;
}

.app-bar__actions__menu{
  border: 0;
  position: relative;
}

.app-bar__user-menu{
  display: none;
  position: absolute;
  top: 42px;
  right: 0;
  background-color: #fff;
  color: var(--primary-color);
  border: 1px solid #36FFD9;
  border-radius: 4px;
  font-size: 14px;
  line-height: 22px;
  padding: 6px 0;
  z-index: 1002;
  min-width: 270px;
  list-style: none;
  max-height: 75vh;
  overflow-y: scroll;
}
.app-bar__actions__menu__item{
  display: block;
  color: var(--primary-color);
  text-decoration: none;
  padding: .5rem 1rem;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  cursor: pointer;
}

.app-bar__actions__menu__item:hover{
  background-color: #E1F0FF;
}

.app-bar__actions__menu:hover ul{
  display: block;
}

.app-bar__actions__mobile-menu{
  color: #ffffff;
  font-weight: 400;
  border-radius: 4px;
  font-size: 22px;
  line-height: 22px;
  padding: 0;
}

.team-notification {
  z-index: 1000;
  padding-top: 2px;
  padding-bottom: 2px;
  font-size: 13px;
  width: 100%;
  text-align: center;
}

@media (max-width: 576px) {
  .team-notification {
    margin-top: -12px !important;
  }
  .app-bar__user-menu--open{
    display: block!important;
  }
  .app-bar__actions__menu:hover ul {
    display: none;
  }

}

/* for desktop and above */
@media (min-width: 768px) {
  .app-bar__actions__btn {
    display: flex;
    align-items: center;
    gap: .5rem;
  }
}

.avatar {
  margin-top: 5px;
  vertical-align: middle;
  width: 35px;
  height: 35px;
  border-radius: 35%;
}

.picture-container {
  background-color: white;
  border: 1px solid #dddddd;
  border-radius: 87.5px;
  max-height: 35px !important;
  min-height: 35px !important;
  max-width: 35px !important;
  min-width: 35px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/base/navbar/AnchorNavbarAuth.vue